/* ============================================================
   BioActive+ Reviews — vanilla interactions for Shopify Dawn
   No dependencies. Progressive enhancement: the page is fully
   readable with JS disabled; this adds filtering, the
   before/after slider, the lightbox, the write-a-review modal,
   helpful voting, and scroll-reveal.

   Re-initialises on Shopify theme-editor events so blocks added
   or reordered in the customizer behave correctly.
   ============================================================ */
(function () {
  "use strict";

  // Sections each reference this asset; the browser may execute it more than
  // once. Boot the global wiring a single time — per-element init is idempotent
  // (guarded by once()) and safe to re-run on Shopify section events.
  if (window.__rvReviewsBooted) return;
  window.__rvReviewsBooted = true;

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function once(el, key) { if (el.dataset[key]) return false; el.dataset[key] = "1"; return true; }

  /* ============================================================
     SCROLL REVEAL  +  BAR / RING FILLS
     ============================================================ */
  function fillEl(el) {
    if (el.hasAttribute("data-rv-fill")) {
      el.style.width = (parseFloat(el.getAttribute("data-pct")) || 0) + "%";
    } else if (el.hasAttribute("data-rv-ring")) {
      var c = $("circle.rv-ring-prog", el) || el.querySelector("circle:last-of-type");
      if (c) {
        var r = parseFloat(c.getAttribute("r")) || 34;
        var circ = 2 * Math.PI * r;
        var pct = parseFloat(el.getAttribute("data-pct")) || 0;
        c.style.strokeDasharray = circ;
        c.style.strokeDashoffset = circ * (1 - pct / 100);
      }
    }
  }

  function initReveal() {
    var found = $all(".reveal:not([data-rv-seen]), [data-rv-fill]:not([data-rv-seen]), [data-rv-ring]:not([data-rv-seen])");
    if (reduceMotion) {
      found.forEach(function (el) { el.dataset.rvSeen = "1"; el.classList.add("in"); fillEl(el); });
      return;
    }
    found.forEach(function (el) { if (revealTargets.indexOf(el) < 0) revealTargets.push(el); });
    checkReveals();
    requestAnimationFrame(checkReveals);
  }

  // scroll/rAF based reveal — robust for zero-area fill bars that an
  // IntersectionObserver threshold would never trigger.
  var revealTargets = [];
  function checkReveals() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var k = revealTargets.length - 1; k >= 0; k--) {
      var el = revealTargets[k];
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.94 && r.bottom > -40) {
        el.dataset.rvSeen = "1";
        el.classList.add("in");
        fillEl(el);
        revealTargets.splice(k, 1);
      }
    }
  }
  window.addEventListener("scroll", checkReveals, { passive: true });
  window.addEventListener("resize", checkReveals);
  window.addEventListener("load", checkReveals);

  /* ============================================================
     REVIEW LIST — filter / sort / toggles / pagination / voting
     ============================================================ */
  function initReviewList(section) {
    if (!once(section, "rvReviewsReady")) return;

    var cardsWrap = $("[data-rv-cards]", section);
    var moreBtn = $("[data-rv-more]", section);
    var moreWrap = moreBtn ? moreBtn.parentNode : null;
    var emptyEl = $("[data-rv-empty]", section);
    var sortSel = $("[data-rv-sort]", section);
    if (!cardsWrap) return;

    var cards = $all(".rcard2", cardsWrap);
    cards.forEach(function (c, i) { c._idx = i; }); // remember authored order = "most recent"

    var state = { filter: "all", minStars: 0, photosOnly: false, sort: "helpful" };

    function pageSize() {
      var d = parseInt(section.getAttribute("data-page-desktop") || "6", 10);
      var m = parseInt(section.getAttribute("data-page-mobile") || "3", 10);
      return (window.matchMedia && window.matchMedia("(max-width: 680px)").matches) ? m : d;
    }
    var shown = pageSize();

    function matches(c) {
      if (state.filter !== "all" && c.getAttribute("data-product") !== state.filter) return false;
      if (state.minStars && (parseInt(c.getAttribute("data-stars"), 10) || 0) < state.minStars) return false;
      if (state.photosOnly && c.getAttribute("data-photo") !== "1") return false;
      return true;
    }
    function sortVal(c, key) {
      if (key === "helpful") return parseInt(c.getAttribute("data-helpful"), 10) || 0;
      if (key === "high" || key === "low") return parseInt(c.getAttribute("data-stars"), 10) || 0;
      return c._idx;
    }
    function render() {
      var list = cards.filter(matches);
      var s = state.sort;
      list.sort(function (a, b) {
        if (s === "recent") return a._idx - b._idx;
        if (s === "low") return sortVal(a, s) - sortVal(b, s) || (b._helpful - a._helpful);
        // helpful / high  -> descending
        var d = sortVal(b, s) - sortVal(a, s);
        if (d !== 0) return d;
        return (parseInt(b.getAttribute("data-helpful"), 10) || 0) - (parseInt(a.getAttribute("data-helpful"), 10) || 0);
      });

      // reflow: hide all, then append the visible slice in order
      cards.forEach(function (c) { c.style.display = "none"; });
      var visible = list.slice(0, shown);
      visible.forEach(function (c) { c.style.display = ""; cardsWrap.appendChild(c); });

      // few-item side-by-side layout
      cardsWrap.classList.remove("few-1", "few-2");
      if (visible.length === 1) cardsWrap.classList.add("few-1");
      else if (visible.length === 2) cardsWrap.classList.add("few-2");

      if (emptyEl) emptyEl.hidden = list.length !== 0;
      if (moreWrap) {
        var remaining = list.length - shown;
        moreWrap.style.display = remaining > 0 ? "" : "none";
        if (remaining > 0) {
          var n = Math.min(pageSize(), remaining);
          var nEl = $("[data-rv-more-n]", moreBtn);
          var leftEl = $("[data-rv-more-left]", moreBtn);
          var ofEl = $("[data-rv-more-of]", moreBtn);
          if (nEl) nEl.textContent = n;
          if (leftEl) leftEl.textContent = "(" + remaining + " left)";
          if (ofEl) ofEl.textContent = state.filter === "all" ? "reviews" : "of these";
        }
      }
    }

    function resetPage() { shown = pageSize(); }

    // filter chips
    $all("[data-rv-filter]", section).forEach(function (chip) {
      chip.addEventListener("click", function () {
        state.filter = chip.getAttribute("data-rv-filter");
        $all("[data-rv-filter]", section).forEach(function (c) { c.classList.toggle("on", c === chip); });
        resetPage(); render();
      });
    });
    // toggles
    $all("[data-rv-toggle]", section).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var kind = btn.getAttribute("data-rv-toggle");
        if (kind === "stars") state.minStars = state.minStars === 5 ? 0 : 5;
        if (kind === "photos") state.photosOnly = !state.photosOnly;
        var on = (kind === "stars") ? state.minStars === 5 : state.photosOnly;
        btn.setAttribute("aria-pressed", on ? "true" : "false");
        var sw = $(".rv-switch", btn); if (sw) sw.classList.toggle("on", on);
        resetPage(); render();
      });
    });
    // sort
    if (sortSel) sortSel.addEventListener("change", function () { state.sort = sortSel.value; resetPage(); render(); });
    // show more
    if (moreBtn) moreBtn.addEventListener("click", function () { shown += pageSize(); render(); });
    // helpful voting
    $all("[data-rv-helpful]", section).forEach(function (btn) {
      var base = parseInt(btn.getAttribute("data-base"), 10) || 0;
      var countEl = $("[data-rv-helpful-n]", btn);
      btn.addEventListener("click", function () {
        var on = btn.classList.toggle("on");
        if (countEl) countEl.textContent = base + (on ? 1 : 0);
      });
    });

    window.addEventListener("resize", function () {
      // keep pagination sensible if breakpoint flips
      if (shown < pageSize()) shown = pageSize();
    });

    render();
  }

  /* ============================================================
     BEFORE / AFTER comparison slider
     ============================================================ */
  function initBeforeAfter(card) {
    if (!once(card, "rvBaReady")) return;
    var stage = $("[data-ba-stage]", card);
    var before = $("[data-ba-before]", card);
    var divider = $("[data-ba-divider]", card);
    var labelL = $(".ba-label.l", card);
    var labelR = $(".ba-label.r", card);
    if (!stage || !before || !divider) return;

    var dragging = false;
    function set(clientX) {
      var r = stage.getBoundingClientRect();
      var pct = Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100));
      before.style.clipPath = "inset(0 " + (100 - pct) + "% 0 0)";
      divider.style.left = pct + "%";
      if (labelL) labelL.style.opacity = pct > 14 ? "1" : "0";
      if (labelR) labelR.style.opacity = pct < 86 ? "1" : "0";
    }
    function down(e) { dragging = true; set(e.touches ? e.touches[0].clientX : e.clientX); e.preventDefault(); }
    function move(e) { if (dragging) set(e.touches ? e.touches[0].clientX : e.clientX); }
    function up() { dragging = false; }
    stage.addEventListener("mousedown", down);
    stage.addEventListener("touchstart", down, { passive: false });
    window.addEventListener("mousemove", move);
    window.addEventListener("touchmove", move, { passive: false });
    window.addEventListener("mouseup", up);
    window.addEventListener("touchend", up);
    set(stage.getBoundingClientRect().width / 2 + stage.getBoundingClientRect().left);
  }

  /* ============================================================
     LIGHTBOX (one per gallery, built on demand)
     ============================================================ */
  var lightbox = null;
  function buildLightbox() {
    if (lightbox) return lightbox;
    var ov = document.createElement("div");
    ov.className = "overlay rv-page";
    ov.setAttribute("data-rv-lightbox-ov", "");
    ov.innerHTML =
      '<figure class="lightbox-fig">' +
        '<button class="lb-close" aria-label="Close">&times;</button>' +
        '<button class="lb-nav prev" aria-label="Previous">&#8249;</button>' +
        '<button class="lb-nav next" aria-label="Next">&#8250;</button>' +
        '<div class="lb-img"></div>' +
        '<figcaption class="lb-info">' +
          '<div class="lb-av"><div class="ph"></div></div>' +
          '<div><div class="lb-name"></div><div class="lb-sub"></div></div>' +
          '<span class="lb-stars"></span>' +
        '</figcaption>' +
      '</figure>';
    document.body.appendChild(ov);
    var fig = $(".lightbox-fig", ov);
    var imgWrap = $(".lb-img", ov);
    var nameEl = $(".lb-name", ov), subEl = $(".lb-sub", ov), starsEl = $(".lb-stars", ov);
    var avPh = $(".lb-av .ph", ov);
    var gallery = [], idx = 0;

    function star(n) { n = parseInt(n, 10) || 5; return "★★★★★".slice(0, n); }

    // Video slides: release the element so a closed/!swiped-past clip stops downloading.
    var curVid = null;
    function stopVideo() {
      if (!curVid) return;
      try { curVid.pause(); } catch (e) {}
      curVid.removeAttribute("src");
      try { curVid.load(); } catch (e) {}
      curVid = null;
    }

    function show(i) {
      idx = (i + gallery.length) % gallery.length;
      var it = gallery[idx];
      stopVideo();
      imgWrap.innerHTML = "";
      if (it.video) {
        var vd = document.createElement("video");
        vd.className = "slot-fill";
        vd.setAttribute("playsinline", "");
        vd.setAttribute("webkit-playsinline", "");
        vd.controls = true;
        vd.loop = true;
        vd.preload = "auto";
        if (it.img) vd.poster = it.img;
        vd.src = it.video;
        imgWrap.appendChild(vd);
        curVid = vd;
        // Opened by a tap, so sound is allowed; fall back to muted if the browser refuses.
        vd.muted = false;
        var pr = vd.play();
        if (pr && pr.catch) pr.catch(function () {
          vd.muted = true;
          var p2 = vd.play();
          if (p2 && p2.catch) p2.catch(function () {});
        });
      } else if (it.img) {
        var im = document.createElement("img");
        im.className = "slot-fill"; im.src = it.img; im.alt = it.name || "Customer photo";
        imgWrap.appendChild(im);
      }
      var ph = document.createElement("div");
      ph.className = "ph";
      if (it.a) ph.style.setProperty("--ph-a", it.a);
      if (it.b) ph.style.setProperty("--ph-b", it.b);
      imgWrap.appendChild(ph);
      nameEl.textContent = it.name || "";
      subEl.textContent = it.sub || "";
      starsEl.textContent = star(it.stars);
      if (it.a) avPh.style.setProperty("--ph-a", it.a);
      if (it.b) avPh.style.setProperty("--ph-b", it.b);
      var multi = gallery.length > 1;
      $(".lb-nav.prev", ov).style.display = multi ? "" : "none";
      $(".lb-nav.next", ov).style.display = multi ? "" : "none";
    }
    function open(items, start) { gallery = items; show(start || 0); ov.classList.add("show"); }
    function close() { stopVideo(); ov.classList.remove("show"); }

    ov.addEventListener("click", function (e) { if (e.target === ov) close(); });
    $(".lb-close", ov).addEventListener("click", close);
    $(".lb-nav.prev", ov).addEventListener("click", function (e) { e.stopPropagation(); show(idx - 1); });
    $(".lb-nav.next", ov).addEventListener("click", function (e) { e.stopPropagation(); show(idx + 1); });
    document.addEventListener("keydown", function (e) {
      if (!ov.classList.contains("show")) return;
      if (e.key === "Escape") close();
      else if (e.key === "ArrowRight") show(idx + 1);
      else if (e.key === "ArrowLeft") show(idx - 1);
    });
    lightbox = { open: open, close: close };
    return lightbox;
  }

  function collectItem(el) {
    return {
      img: el.getAttribute("data-img") || "",
      video: el.getAttribute("data-vsrc") || "",
      name: el.getAttribute("data-name") || "",
      sub: el.getAttribute("data-sub") || "",
      stars: el.getAttribute("data-stars") || "5",
      a: el.getAttribute("data-a") || "",
      b: el.getAttribute("data-b") || ""
    };
  }
  function initGalleries() {
    $all("[data-rv-gallery]").forEach(function (gal) {
      if (!once(gal, "rvGalReady")) return;
      gal.addEventListener("click", function (e) {
        var t = e.target.closest ? e.target.closest("[data-rv-lightbox]") : null;
        if (!t || !gal.contains(t)) return;
        // Only photos currently visible (respects active filters) form the gallery.
        var visible = $all("[data-rv-lightbox]", gal).filter(function (el) { return el.offsetParent !== null; });
        var start = visible.indexOf(t);
        if (start < 0) { visible = [t]; start = 0; }
        buildLightbox().open(visible.map(collectItem), start);
      });
    });
  }

  /* ============================================================
     WRITE-A-REVIEW MODAL
     ============================================================ */
  function initModal() {
    var modalOv = $("[data-rv-write-modal]");
    if (modalOv && once(modalOv, "rvModalReady")) {
      var rating = 0, prod = null;
      var starBtns = $all("[data-star]", modalOv);
      var formEl = $("[data-rv-form]", modalOv);
      var successEl = $("[data-rv-success]", modalOv);
      var submitBtn = $("[data-rv-submit]", modalOv);

      // Always enabled — no validation gate
      if (submitBtn) { submitBtn.disabled = false; submitBtn.style.opacity = "1"; }

      function paint(n) { starBtns.forEach(function (b, i) { b.classList.toggle("lit", i < n); }); }
      starBtns.forEach(function (b, i) {
        b.addEventListener("mouseenter", function () { paint(i + 1); });
        b.addEventListener("click", function () { rating = i + 1; paint(rating); });
      });
      var starInput = $(".star-input", modalOv);
      if (starInput) starInput.addEventListener("mouseleave", function () { paint(rating); });

      $all(".fp[data-prod]", modalOv).forEach(function (chip) {
        chip.addEventListener("click", function () {
          prod = chip.getAttribute("data-prod");
          $all(".fp[data-prod]", modalOv).forEach(function (c) { c.classList.toggle("on", c === chip); });
        });
      });
      var ratingInput = $("[data-rv-field-rating]", modalOv);
      var productInput = $("[data-rv-field-product]", modalOv);
      if (submitBtn) submitBtn.addEventListener("click", function () {
        // Honeypot check - if filled, it's a bot
        var honeypot = ($("[name='contact[website]']", modalOv) || {value:""}).value.trim();
        if (honeypot) {
          // Silently reject bot submissions
          return;
        }
        
        if (ratingInput) ratingInput.value = rating + " stars";
        if (productInput) productInput.value = prod || "";
        var titleVal = ($("[data-rv-field-title]", modalOv) || {}).value || "";
        var bi = $("[data-rv-field-body]", modalOv);
        var formData = new FormData();
        formData.append("form_type", "contact");
        formData.append("utf8", "✓");
        formData.append("contact[email]", ($("[data-rv-field-email]", modalOv) || {value:""}).value.trim() || "no-reply@bioactive.ae");
        formData.append("contact[name]", ($("[data-rv-field-name]", modalOv) || {value:""}).value.trim() || "Anonymous");
        formData.append("contact[body]",
          "⭐ Rating: " + (rating || "-") + "/5\n" +
          "💊 Formula: " + (prod || "-") + "\n" +
          (titleVal ? "📝 Headline: " + titleVal + "\n" : "") +
          "📖 Review:\n" + (bi ? bi.value.trim() : "")
        );
        submitBtn.disabled = true;
        submitBtn.textContent = "Sending…";
        fetch("/contact#contact_form", { method: "POST", body: formData })
          .then(function () {
            if (formEl) formEl.hidden = true;
            if (successEl) successEl.hidden = false;
            setTimeout(closeModal, 2600);
          })
          .catch(function () {
            if (formEl) formEl.hidden = true;
            if (successEl) successEl.hidden = false;
            setTimeout(closeModal, 2600);
          });
      });
      $all("[data-rv-close-modal]", modalOv).forEach(function (x) { x.addEventListener("click", closeModal); });
      // Close only when clicking the dark backdrop (the overlay element itself, not its children).
      modalOv.addEventListener("click", function (e) {
        if (e.target === modalOv) closeModal();
      });
      document.addEventListener("keydown", function (e) { 
        // Only close on Escape if modal is visible and user is not typing in an input
        if (e.key === "Escape" && modalOv.classList.contains("show")) {
          var activeEl = document.activeElement;
          var isTyping = activeEl && (activeEl.tagName === "INPUT" || activeEl.tagName === "TEXTAREA");
          if (!isTyping) closeModal();
        }
      });

      modalOv._reset = function () {
        rating = 0; prod = null; paint(0);
        $all(".fp[data-prod]", modalOv).forEach(function (c) { c.classList.remove("on"); });
        var bi = $("[data-rv-field-body]", modalOv); if (bi) bi.value = "";
        var ni = $("[data-rv-field-name]", modalOv); if (ni) ni.value = "";
        var ei = $("[data-rv-field-email]", modalOv); if (ei) ei.value = "";
        var t = $("[data-rv-field-title]", modalOv); if (t) t.value = "";
        if (formEl) formEl.hidden = false; if (successEl) successEl.hidden = true;
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = "Submit review"; }
      };
    }
    // Use capture-phase delegation on document so this fires before sp2.js
    // and other bubbling-phase handlers, and catches buttons in any section.
    // Also handle the legacy data-rv-open-modal attribute from other sections.
    if (!window.__rvWriteOpenBound) {
      window.__rvWriteOpenBound = true;
      document.addEventListener("click", function (e) {
        // Don't open if modal is already showing
        var m = $("[data-rv-write-modal]");
        if (m && m.classList.contains("show")) return;
        if (!e.target.closest("[data-rv-write-open]") && !e.target.closest("[data-rv-open-modal]")) return;
        e.stopPropagation();
        openModal();
      }, true);
    }
  }
  function openModal() {
    var m = $("[data-rv-write-modal]");
    if (!m) return;
    if (m._reset) m._reset();
    m.classList.add("show");
    document.body.style.overflow = "hidden";
    // Scroll modal body back to top so rating/formula are visible on mobile
    var body = $(".modal-body", m);
    if (body) body.scrollTop = 0;
    var modal = $(".modal", m);
    if (modal) modal.scrollTop = 0;
  }
  function closeModal() {
    var m = $("[data-rv-write-modal]");
    if (m) m.classList.remove("show");
    document.body.style.overflow = "";
  }

  /* ============================================================
     BOOT
     ============================================================ */
  function initAll(scope) {
    var root = scope || document;
    $all("[data-rv-reviews]", root).forEach(initReviewList);
    if (root.matches && root.matches("[data-rv-reviews]")) initReviewList(root);
    $all("[data-rv-ba]", root).forEach(initBeforeAfter);
    if (root.matches && root.matches("[data-rv-ba]")) initBeforeAfter(root);
    initGalleries();
    initModal();
    initReveal();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(); });
  } else {
    initAll();
  }

  // Shopify theme editor: re-init the affected section
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
  document.addEventListener("shopify:section:select", function () { initReveal(); });
  document.addEventListener("shopify:block:select", function () { initReveal(); });
})();
